import constant from "../../store/constant";
import AppHeaderNoauth from "@/components/AppHeaderNoauth";

export default {
  name: "Login",
  components: {
    AppHeaderNoauth
  },
  created() {
    if (window.localStorage.getItem("access_token")) {
      this.authorize();
    }
  },
  data() {
    return {
      loginId: "",
      password: "",
      keepLogin: true,
      errorInfo: "",
      appType: "kanri"
    };
  },
  methods: {
    async authorize() {
      await this.$store.dispatch("AUTHORIZE").catch(err => {
        console.log(err);
        return;
      });
      this.$router.push("/");
    },
    async login() {
      let data = {
        login_id: this.loginId,
        password: this.password,
        app_type: this.appType
      };
      let res = await this.$store
        .dispatch("LOGIN", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        let keepLimit = 0;
        if (!this.keepLogin) {
          let date = new Date();
          keepLimit = date.getTime() + constant.keepLimit;
        }
        window.localStorage.setItem("keep_limit", keepLimit);
        if (res.is_login == 0) {
          this.$router.push("/first_login");
        } else {
          this.$router.push("/");
        }
      }
    }
  }
};
